module.exports = __webpack_public_path__ + "static/media/icon-no-communication.3d9ae795.svg";